function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 1.5
}, React.createElement("g", {
  strokeLinejoin: "round",
  transform: "translate(0 -1090.5)"
}, React.createElement("rect", {
  transform: "rotate(-21.572)",
  x: -404.12,
  y: 1024.9,
  width: 12.5,
  height: 17.5,
  ry: .758
}), React.createElement("path", {
  d: "M9.865 1098.2v-3.457c0-.42.337-.757.757-.757h10.985c.42 0 .758.337.758.757v15.985c0 .42-.338.758-.758.758h-3.27"
}), React.createElement("path", {
  d: "M22.365 1099.2l8.009 4.654c.363.211.485.673.274 1.036l-8.031 13.82a.756.756 0 0 1-1.036.274l-6.704-3.896"
})), React.createElement("path", {
  d: "M8.724 13.6l2.66 6.824M13.465 15.7l-6.824 2.66"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/cards.6f573d24.svg";
export { SvgComponent as ReactComponent };